var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-page center"},[_c('img',{attrs:{"width":"160px","src":require('@/assets/imgs/' + _vm.placeholderImg + '.png'),"alt":""}}),_vm._t("default",function(){return [_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.placeholderText))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }